"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LMNTService = void 0;
var rest_service_1 = require("./rest.service");
var enums_1 = require("../shared/enums");
var role_enum_1 = require("../shared/enums/role.enum");
var text_helper_type_enum_1 = require("../shared/enums/text-helper-type.enum");
var bible_version_enum_1 = require("../shared/enums/bible-version.enum");
/**
 * Class declaration
 */
var LMNTService = /** @class */ (function (_super) {
    __extends(LMNTService, _super);
    /**
     * constructor
     */
    function LMNTService(configService) {
        var _a;
        var _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.LMNT,
            baseURL: configService.config.lmntServiceUrl,
        }) || this;
        _this.helperList = (_a = {},
            _a[text_helper_type_enum_1.TextHelperTypeEnum.DICTIONARY] = {},
            _a[text_helper_type_enum_1.TextHelperTypeEnum.READ_ALOUD] = {},
            _a[text_helper_type_enum_1.TextHelperTypeEnum.SCREENMASK] = {},
            _a[text_helper_type_enum_1.TextHelperTypeEnum.TRANSLATE] = { max_words: 1000 },
            _a);
        _this.launchToken = configService.config.lmntLaunchToken;
        return _this;
    }
    /**
     * createNovaLaunchRequest
     * @param uuid - the activity uuid
     * @returns - the request promise to watch
     */
    LMNTService.prototype.createNovaLaunchRequest = function (uuid, config
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
        var body = this.getRequestBody(config);
        var requestType = enums_1.RequestMethodEnum.POST;
        var headers = this.headers(requestType, false, '/launches/' + uuid);
        headers['Authorization'] = 'Bearer ' + this.launchToken;
        headers['Accept'] = 'application/json, text/plain, */*';
        return this.request('/launches/' + uuid, requestType, body, null, undefined, headers);
    };
    /**
     * getTextHelpers
     * @param helpers - the list of helpers
     * @returns - the text helpers array
     */
    LMNTService.prototype.getTextHelpers = function (helpers) {
        var _this = this;
        if (helpers === void 0) { helpers = [
            text_helper_type_enum_1.TextHelperTypeEnum.DICTIONARY,
            text_helper_type_enum_1.TextHelperTypeEnum.READ_ALOUD,
            text_helper_type_enum_1.TextHelperTypeEnum.SCREENMASK,
            text_helper_type_enum_1.TextHelperTypeEnum.TRANSLATE,
        ]; }
        return helpers === null || helpers === void 0 ? void 0 : helpers.map(function (helper) { return ({
            type: helper,
            properties: _this.helperList[helper],
        }); });
    };
    /**
     * getDefaultContext
     * @param context - the context values
     * @returns - the context with replacements
     */
    LMNTService.prototype.getDefaultContext = function (context) {
        return __assign({ role: role_enum_1.RoleEnum.TEACHER, user_uuid: '3ffe3cd9-8231-4f06-aa05-de8ea7b54118', preview_mode: true, submit_enabled: false, save_enabled: false }, context);
    };
    /**
     * getDefaultValidations
     * @param validations - the validaton to update
     * @returns - the nova validation
     */
    LMNTService.prototype.getDefaultValidations = function (validation) {
        return __assign({ label: 'Hold On Friend!', summary: 'You have unanswered questions', prompt: 'Are you sure you would like to continue submitting this lesson?', cancelAction: 'Cancel', submitAction: 'Continue Submitting' }, validation);
    };
    /**
     * getAssessmentInitialization
     * @param initializations - the initializations to replace
     * @param config - the init_object config to replace
     * @returns - a nova initialization
     */
    LMNTService.prototype.getAssessmentInitialization = function (initialization, initObject, config) {
        return __assign({ signing_required: true, submit_action_title: 'Submit', save_action_title: 'Save', init_object: __assign({ rendering_type: 'inline', organisation_id: '329', user_id: '3ffe3cd9-8231-4f06-aa05-de8ea7b54118', session_id: 'ca7838a1-8933-4308-a67b-77c6f7811139', type: 'submit_practice', state: 'initial', activity_id: 'ae96ab86-2a25-4456-927b-d688d0fd9bef', name: 'Demo Assessment', course_id: 'Demoing 101', events: true, config: __assign({ validateOnSubmit: true, configuration: {
                        events: true,
                    }, renderSaveButton: false, showInstructorStimulus: true, ignore_question_attributes: ['instant_feedback'], renderSubmitButton: false, showCorrectAnswers: false }, config) }, initObject) }, initialization);
    };
    /**
     * getRequestBody
     * @param context - the context to replace defaults with
     * @param validations  - the validation to replace defaults with
     * @param initializations  - the initializations to replace defaults with
     * @returns - the full nova launch config with default replacements
     */
    LMNTService.prototype.getRequestBody = function (config) {
        return __assign({ context: this.getDefaultContext(config === null || config === void 0 ? void 0 : config.context), content_source: 'SEARCH', bible_translation: bible_version_enum_1.BibleVersionEnum.KJV, validations: this.getDefaultValidations(config === null || config === void 0 ? void 0 : config.validation), text_helpers: this.getTextHelpers(config === null || config === void 0 ? void 0 : config.textHelpers), media_options: {
                video_options: {
                    fullScreenEnabled: true,
                },
            }, integrations: {
                assessment_initializations: [
                    this.getAssessmentInitialization(config === null || config === void 0 ? void 0 : config.initialization, config === null || config === void 0 ? void 0 : config.initObject, config === null || config === void 0 ? void 0 : config.initConfig),
                ],
            } }, config === null || config === void 0 ? void 0 : config.config);
    };
    return LMNTService;
}(rest_service_1.RestService));
exports.LMNTService = LMNTService;
